export type FilterType = {
  key?: string
  type: string
  values?: {
    operator?: string
    value?: string | string[]
    sets?: string[]
    w?: boolean
    u?: boolean
    b?: boolean
    r?: boolean
    g?: boolean
    c?: boolean
  }
}

export const DEFAULT_FILTER_VALUE = {
  operator: '>',
  value: '',
}

const DEFAULT_RARITY_FILTER_VALUE = {
  value: 'common',
}

const DEFAULT_COLOR_FILTER_VALUE = {
  w: false,
  u: false,
  b: false,
  r: false,
  g: false,
  c: false,
  operator: 'EXCLUSIVE ALL',
}

const DEFAULT_SETS_FILTER_VALUE = {
  operator: 'INCLUDE',
  value: '',
}

export const DEFAULT_FILTER_VALUE_MAP = {
  manaValue: DEFAULT_FILTER_VALUE,
  power: DEFAULT_FILTER_VALUE,
  price: DEFAULT_FILTER_VALUE,
  toughness: DEFAULT_FILTER_VALUE,
  rarity: DEFAULT_RARITY_FILTER_VALUE,
  colors: DEFAULT_COLOR_FILTER_VALUE,
  sets: DEFAULT_SETS_FILTER_VALUE,
}
